// src/firebase.js
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDcj5g-_eRokwfI5Jz7rppcom2RUzp0AOI",
    authDomain: "insightout-club.firebaseapp.com",
    projectId: "insightout-club",
    storageBucket: "insightout-club.firebasestorage.app",
    messagingSenderId: "1037133492998",
    appId: "1:1037133492998:web:db4811343b48076fdca487",
    measurementId: "G-C8E23T9CMX"
};
  


const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app) // <-- Storage referansı